import ANavigationItem from './index.vue';

ANavigationItem.install = app => {
  app.component(ANavigationItem.name, ANavigationItem);
};

export default ANavigationItem;
